//
// wrapper around axios to include Rails CSRF token
//
import axios from 'axios';
import qs from 'qs';

const token = document.querySelector('[name="csrf-token"]') || { content: 'no-csrf-token' };
const ax = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    common: {
      'X-CSRF-Token': token.content
    }
  }
});

ax.CancelToken = axios.CancelToken;
ax.isCancel = axios.isCancel;

ax.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    return qs.stringify(params, {
      arrayFormat: "brackets",
      encode: false
    });
  };

  return config;
});

export default ax;
